<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog
      v-model="json_data.status"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
    >
      <v-card style="background-color: #eeeeee">
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{ $t("close") }}</span>
          </v-tooltip>
          <v-toolbar-title>{{
            json_data.save_type == "create"
              ? $t("menu.TakeLeaveCreate")
              : $t("menu.TakeLeaveEdit")
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            flat
            dark
            @click="json_data.save_type == 'create' ? onSave() : onUpdate()"
          >
            <v-icon>save</v-icon>
            <span class="px-2">{{
              json_data.save_type == "create" ? $t("create") : $t("save")
            }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-4>
            <v-layout
              row
              wrap
              pa-4
              style="
                background-color: #fff;
                margin-top: 5px;
                border-radius: 5px;
              "
            >
              <v-flex xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('doc_no')"
                        append-icon="fas fa-plus-circle"
                        v-if="json_data.save_type == 'create'"
                        v-model="form_model.doc_no"
                        :rules="form_rules.doc_no"
                        required
                        hide-details
                        @click:append="doNewGuid"
                      />
                      <v-text-field
                        v-else
                        :label="$t('doc_no')"
                        append-icon="fas fa-plus-circle"
                        v-model="form_model.doc_no"
                        :rules="form_rules.doc_no"
                        required
                        readonly
                        hide-details
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-autocomplete
                        hide-details
                        :loading="loading"
                        v-model="form_model.emp_code"
                        :items="Employee_List"
                        item-text="name"
                        item-value="code"
                        :label="$t('employee_code')"
                        allow-overflow
                        append-icon="search"
                        clearable
                        required
                        :rules="form_rules.emp_code"
                        @change="checkworkplan()"
                      />
                    </v-flex>
                    <v-flex md12 sm12 xs12 py-2 px-1>
                      <h3>{{ $t("TakeLeave_dialog") }}</h3>
                      <v-layout row wrap>
                        <v-flex md12 sm12 xs12 pa-1>
                          <v-radio-group
                            v-model="form_model.is_day"
                            :column="false"
                            hide-details
                            @change="redate()"
                          >
                            <template>
                              <v-radio :label="$t('hour')" value="0" />
                              <v-radio :label="$t('allday')" value="1" />
                            </template>
                          </v-radio-group>
                        </v-flex>
                        <v-flex lg4 md6 sm6 xs12 pa-1>
                          <v-text-field
                            :label="$t('from')"
                            v-model="begin_date"
                            :type="
                              form_model.is_day == '0'
                                ? 'datetime-local'
                                : 'date'
                            "
                            required
                            hide-details
                             @change="checkworkplan()"
                          />
                        </v-flex>
                        <v-flex lg4 md6 sm6 xs12 pa-1>
                          <v-text-field
                            :label="$t('to')"
                            v-model="end_date"
                            :type="
                              form_model.is_day == '0'
                                ? 'datetime-local'
                                : 'date'
                            "
                            required
                            hide-details
                             @change="checkworkplan()"
                          />
                        </v-flex>
                        <v-flex lg4 md6 sm6 xs12 pa-1 v-if="form_model.is_day =='0'">
                          <v-text-field
                            type="number"
                            :label="$t('TotalLeaveHours')"
                            v-model="form_model.total_hour"
                            :rules="form_rules.hour"
                          />
                        </v-flex>
                        <v-flex lg4 md6 sm6 xs12 pa-1 v-if="form_model.is_day =='1'">
                          <v-text-field
                            type="number"
                            :label="$t('Perday')+'('+$t('Hour')+')'"
                            v-model="form_model.total_hour"
                            :rules="form_rules.hour"
                          />
                        </v-flex>
                        <v-flex lg4 md6 sm6 xs12 pa-3  v-if="form_model.is_day =='1'">
                         <span v-html="textdate"></span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-select
                        :items="leave_types"
                        v-model="form_model.leave_type"
                        :label="$t('TakeLeave_dialog_Leavetype')"
                        item-text="name"
                        item-value="code"
                        hide-details
                        :disabled="
                          form_model.emp_code == '' ||
                          form_model.emp_code == undefined
                        "
                        @change="
                          leavechange(
                            form_model.emp_code,
                            form_model.leave_type
                          )
                        "
                      ></v-select>
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <span  v-bind:style="[msgcolor == 0 ? {'color':'#4CAF50'}:{'color':'#D50000'}]">{{ msg }}</span>
                    </v-flex>
                    <v-flex md12 sm12 xs12 py-2 px-1>
                      <h3>{{ $t("TakeLeave_dialog_deuctiontype") }}</h3>
                      <v-layout row wrap>
                        <v-flex md6 sm6 xs12 pa-1>
                          <v-radio-group
                            v-model="form_model.certificate"
                            :column="false"
                            hide-details
                          >
                            <template>
                              <v-radio :label="$t('Deductions')" value="0" />
                              <v-radio
                                :label="$t('LeaveNotDeductingMoney')"
                                value="1"
                              />
                            </template>
                          </v-radio-group>
                        </v-flex>
                        <v-flex
                          md6
                          sm6
                          xs12
                          pa-1
                          v-if="form_model.certificate == '0'"
                        >
                          <v-text-field
                            type="number"
                            :label="$t('Hour')"
                            v-model="form_model.deduct_hour"
                            :rules="form_rules.hour"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex md12 sm12 xs12 pa-1>
                      <v-textarea
                        :label="$t('remark')"
                        v-model="form_model.remark"
                        hide-details
                      />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn
                color="success"
                @click="json_data.save_type == 'create' ? onSave() : onUpdate()"
              >
                <v-icon>save</v-icon>
                <span class="px-2">{{
                  json_data.save_type == "create" ? $t("create") : $t("save")
                }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar
      v-model="snack_model.status"
      :timeout="3500"
      :top="'top'"
      :color="snack_model.type"
    >
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import Utils from "@/utils/";
import DocumentService from "@/services/DocumentService";
import MasterService from "@/services/MasterService";
import moment from "moment";

export default {
  props: {
    json_data: Object,
  },
  watch: {
    json_data(val) {
      this.doNewGuid();
      if (val.data != null) {
        this.form_model = val.data;
        this.form_model.leave_type = val.data.leave_type.toString();
        this.form_model.is_day = val.data.is_day.toString();
        this.form_model.certificate = val.data.certificate.toString();
        this.dialog_loading = false;
        this.getDetail(this.form_model.roworder);
        console.log(this.form_model);
      } else {
        this.$refs.form.resetValidation();
      }
    },
  },
  data: () => ({
    form_valid: false,
    msg: "",
    msgcolor:"",
    textdate:"",
    sumhour: 0,
    form_model: {
      emp_code: "",
      begin_datetime: "",
      end_datetime: "",
      leave_type: " ",
      remark: "",
      is_day: "0",
      doc_no: "",
      certificate: "1",
      leave_type: "0",
      deduct_hour: 0,
      total_hour: 0,
      creator_code: localStorage._usercode,
      company_id: localStorage._company_guid,
    },
    begin_date: "",
    end_date: "",
    leave_types: [
      {
        code: "0",
        name: "ลาอื่นๆ",
      },
      {
        code: "1",
        name: "ลากิจ",
      },
      {
        code: "2",
        name: "ลาป่วย",
      },
      {
        code: "3",
        name: "ลาพักร้อน",
      },
      {
        code: "4",
        name: "ลาบวช",
      },
      {
        code: "5",
        name: "ลาคลอด",
      },
      {
        code: "6",
        name: "ลารับราชการทหาร",
      },
    ],
    form_rules: {
      emp_code: [(v) => !!v || "กรุณากรอกข้อมูล."],
      end_datetime: [(v) => !!v || "กรุณากรอกข้อมูล."],
      begin_datetime: [(v) => !!v || "กรุณากรอกข้อมูล."],
      hour: [(v) => !!v || "กรุณากรอกข้อมูล."],
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
  }),
  created: function () {
    this.getEmployee("newData");
    this.doNewGuid();
  },
  computed: {
    ...mapState("filter", ["loading", "Employee_List"]),
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    closeDialog() {
      this.clearForm();
      this.$emit("close-dialog");
    },
    doNewGuid() {
      this.form_model.doc_no = Utils.newGuid("B");
    },
    clearForm() {
      (this.form_model = {
        emp_code: "",
        begin_datetime: "",
        end_datetime: "",
        leave_type: "0",
        remark: "",
        is_day: "0",
        doc_no: "",
        certificate: "0",
        leave_type: "0",
        deduct_hour: 0,
        total_hour: 0,
        creator_code: localStorage._usercode,
      }),
        (this.begin_date = ""),
        (this.end_date = "");
        (this.msg= "");
         (this.textdate= "");
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    getDetail(param) {
      DocumentService.getTakeLeaveByCode(param)
        .then((res) => {
          this.showLoading = false;
          this.form_model = res.data;
          this.form_model.is_day = this.form_model.is_day.toString();
          this.form_model.certificate = this.form_model.certificate.toString();
          this.form_model.leave_type = this.form_model.leave_type.toString();
          let begindate_split = this.form_model.begin_datetime.split(":");
          let enddate_split = this.form_model.end_datetime.split(":");
          let begindate = begindate_split[0] + ":" + begindate_split[1];
          let enddate = enddate_split[0] + ":" + enddate_split[1];
          if (this.form_model.is_day == "0") {
            this.begin_date = begindate.replace(" ", "T");
            this.end_date = enddate.replace(" ", "T");
          } else {
            this.begin_date = begindate.split(" ")[0];
            this.end_date = enddate.split(" ")[0];
          }
        })
        .catch((err) => {
          this.showSnackBar(err.response.data, "error");
        });
    },
    onSave() {
      if (this.form_model.is_day == "0") {
        this.form_model.begin_datetime =
          this.begin_date.replace("T", " ") + ":00.0";
        this.form_model.end_datetime =
          this.end_date.replace("T", " ") + ":00.0";
      } else {
        this.form_model.begin_datetime = this.begin_date + " 00:00:00.0";
        this.form_model.end_datetime = this.end_date + " 23:59:59.0";
      }

      if (
        this.form_valid &&
        this.form_model.begin_datetime != "" &&
        this.form_model.end_datetime != ""
      ) {
        this.form_model.company_id = localStorage._company_guid
        DocumentService.createTakeleave(this.form_model)
          .then((res) => {
            this.showSnackBar("save success", "success");
            this.closeDialog();
          })
          .catch((err) => {
            this.showSnackBar(err.response.data, "error");
          });
      } else {
        this.$refs.form.validate();
      }
    },
    onUpdate() {
      if (this.form_model.is_day == "0") {
        this.form_model.begin_datetime =
          this.begin_date.replace("T", " ") + ":00.0";
        this.form_model.end_datetime =
          this.end_date.replace("T", " ") + ":00.0";
      } else {
        this.form_model.begin_datetime = this.begin_date + " 00:00:00.0";
        this.form_model.end_datetime = this.end_date + " 23:59:59.0";
      }

      if (
        this.form_valid &&
        this.form_model.begin_datetime != "" &&
        this.form_model.end_datetime != ""
      ) {
        this.form_model.company_id = localStorage._company_guid
        DocumentService.updateTakeleave(this.form_model)
          .then((res) => {
            this.showSnackBar("update success", "success");
            this.closeDialog();
          })
          .catch((err) => {
            this.showSnackBar(err.response.data, "error");
          });
      } else {
        this.$refs.form.validate();
      }
    },

    async leavechange(emp_code, item) {
      console.log(this.form_model.deduct_hour);
      if (
        this.begin_date != null &&
        this.begin_date != "" &&
        this.end_date != null &&
        this.end_date != ""
      ) {
        var cur = new Date(this.begin_date).toISOString().substr(0, 4);
        var balance = {};
        var use = {};
        this.msg = "";
        this.sumhour = 0;
        var totalhour = 0;
        if(this.form_model.is_day =='1'){
          var d1 = new Date(this.begin_date).getTime();
          var d2 = new Date(this.end_date).getTime();
          var diff = d2-d1;
          let diffDays = diff / (24 * 60 * 60 * 1000);
          console.log(diffDays+1)
          totalhour = (diffDays+1) * this.form_model.total_hour;
        }else if(this.form_model.is_day =='0'){
           totalhour = this.form_model.total_hour;
        }

        await MasterService.getDetailsLeaveByCode(emp_code, cur)
          .then((res) => {
            console.log(res);
            balance = res.data;
          })
          .catch({});

        await DocumentService.checkleave(
          emp_code,
          this.form_model.is_day,
          this.begin_date,
          this.end_date,
          item
        )
          .then((res) => {
            use = res.data;
            console.log(use);
          })
          .catch({});

        switch (item) {
          case "0":
            this.sumhour = balance.other_leave_hour - use.other_leave_use;
            if (this.sumhour > 0) {
              this.msg = "ประเภท ลาอื่น ๆ เหลือ " + this.sumhour + " ชั่วโมง";
              this.msgcolor = 0
              if (this.sumhour < totalhour) {
                this.form_model.deduct_hour =
                 totalhour - this.sumhour;
                this.form_model.certificate = "0";
              } else {
                this.form_model.deduct_hour = 0;
                this.form_model.certificate = "1";
              }
            } else {
              this.msg = "ประเภท ลาอื่น ๆ เหลือ 0 ชั่วโมง";
               this.msgcolor = 1
              this.form_model.deduct_hour = totalhour;
              this.form_model.certificate = "0";
            }
            break;
          case "1":
            this.sumhour = balance.personal_leave_hour - use.personal_leave_use;
            if (this.sumhour > 0) {
              this.msg = "ประเภท ลากิจ เหลือ " + this.sumhour + " ชั่วโมง";
               this.msgcolor = 0
              if (this.sumhour < totalhour) {
                this.form_model.deduct_hour =
                  totalhour - this.sumhour;
                this.form_model.certificate = "0";
              } else {
                this.form_model.deduct_hour = 0;
                this.form_model.certificate = "1";
              }
            } else {
              this.msg = "ประเภท ลากิจ เหลือ 0 ชั่วโมง";
               this.msgcolor = 1
              this.form_model.deduct_hour = totalhour;
              this.form_model.certificate = "0";
            }
            break;
          case "2":
            this.sumhour = balance.sick_leave_hour - use.sick_leave_use;
            if (this.sumhour > 0) {
              this.msg = "ประเภท ลาป่วย เหลือ " + this.sumhour + " ชั่วโมง";
               this.msgcolor = 0
              if (this.sumhour < totalhour) {
                this.form_model.deduct_hour =
                  totalhour - this.sumhour;
                this.form_model.certificate = "0";
              } else {
                this.form_model.deduct_hour = 0;
                this.form_model.certificate = "1";
              }
            } else {
              this.msg = "ประเภท ลาป่วย เหลือ 0 ชั่วโมง";
               this.msgcolor = 1
              this.form_model.deduct_hour = totalhour;
              this.form_model.certificate = "0";
            }
            break;
          case "3":
            this.sumhour = balance.vacation_leave_hour - use.vacation_leave_use;
            if (this.sumhour > 0) {
              this.msg = "ประเภท ลาพักร้อน เหลือ " + this.sumhour + " ชั่วโมง";
               this.msgcolor = 0
              if (this.sumhour < totalhour) {
                this.form_model.deduct_hour =
                 totalhour - this.sumhour;
                this.form_model.certificate = "0";
              } else {
                this.form_model.deduct_hour = 0;
                this.form_model.certificate = "1";
              }
            } else {
              this.msg = "ประเภท ลาพักร้อน เหลือ 0 ชั่วโมง";
               this.msgcolor = 1
              this.form_model.deduct_hour = totalhour;
              this.form_model.certificate = "0";
            }
            break;
          case "4":
            this.sumhour =
              balance.ordination_leave_hour - use.ordination_leave_use;
            if (this.sumhour > 0) {
              this.msg = "ประเภท ลาบวช เหลือ " + this.sumhour + " ชั่วโมง";
               this.msgcolor = 0
              if (this.sumhour < totalhour) {
                this.form_model.deduct_hour =
                  totalhour - this.sumhour;
                this.form_model.certificate = "0";
              } else {
                this.form_model.deduct_hour = 0;
                this.form_model.certificate = "1";
              }
            } else {
              this.msg = "ประเภท ลาบวช เหลือ 0 ชั่วโมง";
               this.msgcolor = 1
              this.form_model.deduct_hour = totalhour;
              this.form_model.certificate = "0";
            }
            break;
          case "5":
            this.sumhour =
              balance.maternity_leave_hour - use.maternity_leave_use;
            if (this.sumhour > 0) {
              this.msg = "ประเภท ลาคลอด เหลือ " + this.sumhour + " ชั่วโมง";
               this.msgcolor = 0
              if (this.sumhour < totalhour) {
                this.form_model.deduct_hour =
                  totalhour - this.sumhour;
                this.form_model.certificate = "0";
              } else {
                this.form_model.deduct_hour = 0;
                this.form_model.certificate = "1";
              }
            } else {
              this.msg = "ประเภท ลาคลอด เหลือ 0 ชั่วโมง";
               this.msgcolor = 1
              this.form_model.deduct_hour = totalhour;
              this.form_model.certificate = "0";
            }
            break;
          case "6":
            this.sumhour =
              balance.military_service_leave_hour -
              use.military_service_leave_use;
            if (this.sumhour > 0) {
              this.msg =
                "ประเภท ลารับราชการทหาร เหลือ " + this.sumhour + " ชั่วโมง";
                 this.msgcolor = 0
              if (this.sumhour < totalhour) {
                this.form_model.deduct_hour =
                  totalhour - this.sumhour;
                this.form_model.certificate = "0";
              } else {
                this.form_model.deduct_hour = 0;
                this.form_model.certificate = "1";
              }
            } else {
              this.msg = "ประเภท ลารับราชการทหาร เหลือ 0 ชั่วโมง";
              this.msgcolor = 1
              this.form_model.deduct_hour = totalhour;
              this.form_model.certificate = "0";
            }
            break;
        }
      } else {
        this.showSnackBar("จากวันที่ถึงวันที่ก่อนเลือกประเภทการลา", "error");
      }
      console.log(emp_code);
      console.log(item);
    },

    checkworkplan(){

      var daytext =[];
      var text ="";
       if(this.form_model.is_day == '1'){
      if(this.begin_date != null && this.begin_date != "" && this.end_date != null && this.end_date != "" && this.form_model.emp_code != undefined && this.form_model.emp_code != ""){
          
          console.log(this.dateformat(this.begin_date))
          console.log(this.dateformat(this.end_date))
         
            MasterService.getTimeCheckInByEmp(this.dateformat(this.begin_date),this.dateformat(this.end_date),this.form_model.emp_code)
             .then((res) => {      
            console.log(res.data[0].processTimes);

              let resData = this.groupBy( res.data[0].processTimes, "total_workhour");
                 for (let item in resData) {
                   text += `<span>วันที่ทำงานวันละ `+item+` ชั่วโมง มีดังนี้<span><br>`;
                  resData[item].forEach(element => {
                    text += `<span> &nbsp;`+this.dateformattext(element.date)+`<span><br>`;
                   
                  });
                    
                 }
                 this.textdate = text;
                 console.log(text);


               
            // res.data[0].processTimes.forEach(element => {
              
            // });    
          })
          .catch({});
          }
           


      }
      
      
    },
     groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    dateformat(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    dateformattext(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    redate(){
      this.begin_date ="";
      this.end_date = "";
      this.textdate = "";
    }
    
  },
};
</script>
<style>
.v-input--selection-controls {
  margin-top: 0;
}
.v-card__text {
  padding: 0px !important;
}
</style>